import * as Images from "./ImageImports.js";

export const COMPONENT_DATA = {
  "Blotting Paper": Images.Blotting_Paper,
  CellSpreader: Images.CellSpreader,
  Chromatography: Images.ChromatographyColumn,
  Flask: { TBST: Images.OneX_Sodium_Borate_Buffer, Milk: Images.Falcon_Milk },
  "Floating Tube Rack": Images.floatingTubeRack,
  Freezer: Images.freezer_closed,
  "Filter Paper": Images.FilterPaper,
  Gel: {
    Gel: Images.Agarose_Gel,
    ProteinGel: Images.ProteinGel,
    Polyacrylamide: Images.PolyacrylamideGel,
  },
  "Gel Box": {
    "Gel Electrophoresis Box": Images.Gel_Electrophoresis_Box,
    "Protein Gel Electrophoresis Box": Images.Protein_Gel_Electrophoresis_Box,
  },
  "Ice Bucket": Images.IceBucket,
  Incubator: Images.Incubator,
  LabTape: Images.LabTape,
  "Lab Shaker": Images.LabShaker,
  Microcentrifuge: Images.Microcentrifuge,
  Petridish: {
    LB: Images.petridishLB,
    "LB/amp": Images.petridishLBAMP,
    "LB/amp/ara": Images.petridishLBAMPARA,
  },
  Pipette: {
    P2: Images.P2_Pipette,
    P20: Images.P20_Pipette,
    P200: Images.P200_Pipette,
    P1000: Images.P1000_Pipette,
    "10mL": Images.ML10_Pipette,
  },
  Solution: {
    Binding: Images.SolutionFalconBB,
    ColumnEquilibrationBuffer: Images.SolutionFalconCEB,
    Elution: Images.SolutionFalconEB,
    Wash: Images.SolutionFalconWB,
    "SDS Buffer": Images.SDSBuffer,
    "Cell Culture": Images.cellCulture,
    "Protein Ladder": Images.proteinLadder,
  },
  "Power Supply": {
    "Power Supply": Images.Power_Supply,
    "Power Supply New": Images.Power_Supply_New,
  },
  "Power Supply Lead": Images.Power_Supply_Leads,
  "Tip Box": {
    P2: Images.P2_Tip_Box,
    P20: Images.P20_Tip_Box,
    P200: Images.P200_Tip_Box,
    P1000: Images.P1000_Tip_Box,
  },
  Trash: {
    Trash: Images.Trash,
    Biohazard: Images.Biohazardous,
  },
  Vortex: Images.Vortex,
  "Water Bath": Images.WaterBath,
  "Waste Collection Jar": Images.WasteCollectionJar,
  "Heat Block": Images.HeatBlock,
  "Western Blot Imager": Images.WesternBlotImager,
  "Western Blot Transfer Apparatus": Images.WesternBlotTransferApparatus,
  Timer: Images.Timer,
  Roller: Images.Roller,
  "Western Blot Box": Images.TransferBufferBox,
  "Transfer Buffer Box": Images.TransferBufferBox,
  "Nitrocellulose Membrane": Images.NitrocelluloseMembrane,
  "Experimental setup poster": Images.ExperimentalPoster,
  "pH scale poster": Images.pHscalePoster,
  Spectrophotometer: Images.Spectrophotometer,
  Cuvette: Images.Cuvette,
  "Cuvette lid": Images.CuvetteLid,
  "Blank cuvette": Images.CuvetteBlank,
  "Cuvette rack": Images.CuvetteRack,
  "Glass tubes": Images.GlassTube,
  "Elodea water plant": Images.ElodeaWaterPlant,
  "Rubber stopper": Images.RubberStopper,
  "LED lamp": Images.LEDLamp,
  "Light-blocking box": Images.LightBlockingBox,
  Beaker: {
    Beaker: Images.Beaker,
    "Beaker A": Images.BeakerA,
    "Beaker B": Images.BeakerB,
    "Beaker C": Images.BeakerC,
    "Beaker D": Images.BeakerE,
    "Beaker E": Images.BeakerD,
    "Beaker F": Images.BeakerF,
  },
  "Dialysis tube": Images.DialysisTube,
  "Electronic balance": {
    "Electronic balance": Images.ElectronicScale,
  },
  "Paper towels": {
    "Paper towels": Images.PaperTowel,
  },
  Microscope: Images.Microscope,
  "Blank Slides": Images.BlankSlides,
  "Cover Slips": Images.CoverSlips,
  "Lens Cleaning Wipes": Images.LensCleaningWipes,
  "Mystery Specimens": Images.MysterySpecimens,
  "Lab Notebook": Images.LabNotebook,
  Egg: {
    Box: Images.Eggbox,
  },
  Vinegar: Images.Vinegar,
  "DI Water": Images.DIWater,
  "Salt Water": Images.SaltWater,
  "Corn Syrup": Images.CornSyrup,
  "Plastic Wrap": Images.PlasticWrap,
  Tray: Images.Tray,
  Bottle: {
    DH20: Images.DH20,
    G: Images.G,
    H202: Images.H2O2,
    TP: Images.TP,
    PH3: Images.PH3,
    PH4: Images.PH4,
    PH5: Images.PH5,
    PH6: Images.PH6,
    PH7: Images.PH7,
    PH8: Images.PH8,
    PH9: Images.PH9,
    PH10: Images.PH10,
    PH11: Images.PH11,
  },
  Tube: {
    "Tinted Tube": Images.TintedTube,
    "3E": Images.E3,
    "4E": Images.E4,
    "5E": Images.E5,
    "6E": Images.E6,
    "7E": Images.E7,
    "8E": Images.E8,
    "9E": Images.E9,
    "10E": Images.E10,
    "11E": Images.E11,
  },
  Microplate: {
    "96 Well": Images.Microplate_96_Well,
    Reader: Images.Microplate_Reader,
  },
  PPE: {
    "Lab Coat": Images.LabCoat,
    "Safety Goggles": Images.SafetyGoggles,
    "Protective Gloves": Images.ProtectiveGloves,
  },
  "Slotted Spoon": Images.SlottedSpoon,
  "Lab Coat": Images.LabCoat,
  Goggles: Images.Goggles,
  Gloves: Images.Gloves,
  Soap: Images.Soap,
  Mitosis: {
    Calculator: Images.Calculator,
    Microscope: Images.microscope,
    Notebook: Images.notebook,
    SlideHolder: Images.slideHolder,
    MitosisPoster: Images.mitosisPoster,
    PlusLectin: Images.plusLectin,
    MinusLectin: Images.minusLectin,
  },
  Meiosis: {
    MeiosisPoster: Images.meiosisPoster,
    WttanLectin: Images.wttanLectin,
  },
  Glass: Images.Glass,
  Balloon: Images.Balloon,
  GenericFlask: Images.Flask,
  Fridge: Images.Fridge,
  Glasses: Images.Glasses,
  GraduagedCylinder: Images.GraduagedCylinder,
  Notebook: Images.Notebook,
  Sugar: Images.Sugar,
  Water: Images.Water,
  Yeast: Images.Yeast,
  "Bean Plant": Images.BeanPlant,
  Calendar: Images.Calendar,
  "Electronic Balance PT": Images.ElectronicBalancePT,
  "Graph Paper": Images.GraphPaper,
  "Plastic Container": Images.PlasticContainer,
  "Plastic Wrap PT": Images.PlasticWrapPT,
  Fertilizer: Images.Fertilizer,
  "Grow lights": Images.GrowLight,
  "Plug tray": Images.PlugTray,
  "Wisconsin Fast Plant seeds": Images.Seeds,
  Soil: Images.Soil,
  "Aluminum weigh boat": Images.WeighBoat,
};

export function getImageData(component, props) {
  switch (COMPONENT_DATA[component] instanceof Object) {
    default:
      return COMPONENT_DATA[component][props.type];
    case false:
      return COMPONENT_DATA[component];
  }
}
